export const colors = {
  mainColor: "#40A6DE",
  disabledColor: "#9ACEF8",
  undisabledColor: "#C4C4C4",
  placeHolderColor: "#C4C4C4",
  textColor: "#767676",
  blackColor: "#000000",
  whiteColor: "#ffffff",
  alertColor: "#EB5757",
};

export const fontSize = {
  xsmall: "0.625rem", // 10px
  small: " 0.75rem", // 12px
  medium: "0.875rem", // 14px
  large: "1.125rem", // 18px
  xlarge: "1.5rem", // 24px
};

const Theme = {
  colors,
  fontSize,
};

export default Theme;
